import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * author Tari
 * @dateCreated 08 Apr 2025
 * @description Intercepts errors with X-Security-Error header.
 */
@Injectable()
export class XSecurityErrorResponseInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        const securityError =
          error.headers && error.headers.get('X-Security-Error');

        if (securityError) {
          const message = this.removeDuplicates(securityError);
          const status =
            error?.error?.statusCode ??
            error?.status ??
            error?.statusCode ??
            '500';

          const errorObj = { error: message, errorMessage: message };

          return throwError({
            ...errorObj,
            data: { ...errorObj },
            status: status,
          });
        }

        return throwError(error);
      })
    );
  }

  removeDuplicates(input: string): string {
    const messages = input.split(', ');

    // Use Set to automatically filter out duplicate messages
    const uniqueMessages = [...new Set(messages)];

    // Join the unique messages back into a string
    return uniqueMessages.join(', ');
  }
}
